import { render, staticRenderFns } from "./AppraisalFacetScores.vue?vue&type=template&id=41e3f502&"
import script from "./AppraisalFacetScores.vue?vue&type=script&lang=ts&"
export * from "./AppraisalFacetScores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports